import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cruiseControlFilled"
const CruiseControlFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.212 18.06C10.73 17.163 11.877 16.856 12.774 17.374S13.978 19.038 13.46 19.935 11.795 21.14 10.898 20.621 9.696 18.957 10.213 18.061" />
          <path
            fillRule="evenodd"
            d="M12 3C13.936 3 15.836 3.536 17.487 4.548 19.137 5.559 20.477 7.008 21.355 8.733 22.235 10.46 22.62 12.393 22.468 14.324 22.327 16.117 21.727 17.843 20.73 19.334 20.448 19.755 19.98 19.981 19.506 19.981H15.065C15.482 18.614 14.989 17.103 13.8 16.254L15.646 13.132C15.856 12.775 15.738 12.315 15.382 12.104 15.025 11.894 14.565 12.012 14.354 12.368L12.404 15.67C11.052 15.44 9.639 16.053 8.913 17.31 8.426 18.153 8.345 19.118 8.608 19.981H4.494C4.02 19.981 3.552 19.755 3.27 19.334 2.273 17.844 1.674 16.118 1.532 14.324 1.38 12.394 1.766 10.459 2.645 8.734 3.524 7.007 4.863 5.558 6.514 4.547 8.164 3.536 10.064 3 12 3M3.724 14.25H5.974V12.75H3.724zM18 14.25H20.25V12.75H18zM5.47 8.405 7.06 9.996 8.122 8.936 6.531 7.345zM15.97 8.935 17.03 9.997 18.621 8.406 17.561 7.344zM11.25 7.5H12.75V5.25H11.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CruiseControlFilledIcon
